import { computed } from 'vue';

import { useProfile } from '@/store';

const RECIPIENTS = 'mark@stuut.co,hunter@stuut.co';

/**
 * Builds the "contact Stuut to enable disputes" mailto link, worded for the org's
 * current state: orgs that already have base disputes are asking to upgrade to
 * Disputes Pro; orgs with neither are requesting the base disputes module.
 */
export function useDisputesAccessRequest() {
  const profileStore = useProfile();

  const mailtoLink = computed(() => {
    const isUpgrade = profileStore.isBaseDisputesEnabled;
    const subject = isUpgrade ? 'Enable Disputes Pro' : 'Enable Disputes Module';
    const product = isUpgrade ? 'Disputes Pro' : 'the disputes module';
    const body = `Hi Stuut team,\n\nI would like to enable ${product} for my organization.\n\nThank you!`;
    return `mailto:${RECIPIENTS}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  });

  const requestAccess = () => {
    window.location.href = mailtoLink.value;
  };

  return { mailtoLink, requestAccess };
}
